export default class FileMetadataModel {
  Activity: string;
  Activities:
    | {
        value: string;
        selected: boolean;
      }[]
    | undefined;
  Authorization: string;
  Company: string;
  CurrentStatus: string;
  Description: string;
  Expiry: string;
  MaxLat: string;
  MaxLong: string;
  MinLat: string;
  MinLong: string;
  Name: string;
  RO: string;
  Region: string;
  SpecLocation: string;
  Start?: string;
  Status: string;
  Url: string;
  PartitionKey: string;
  RowKey: string;
  Location:
    | {
        latitude: number;
        longitude: number;
        latlng: string;
      }
    | undefined;

  constructor(data: any = {}) {
    this.Activity = data.Activity || undefined;
    this.Activities = data.Activities || [];
    this.Authorization = data.Authorization || undefined;
    this.Company = data.Company || undefined;
    this.CurrentStatus = data.CurrentStatus || undefined;
    this.Description = data.Description || undefined;
    this.Expiry = data.Expiry || undefined;
    this.MaxLat = data.MaxLat || undefined;
    this.MaxLong = data.MaxLong || undefined;
    this.MinLat = data.MinLat || undefined;
    this.MinLong = data.MinLong || undefined;
    this.Name = data.Name || undefined;
    this.RO = data.RO || undefined;
    this.Region = data.Region || undefined;
    this.SpecLocation = data.SpecLocation || undefined;
    this.Start = data.Start || undefined;
    this.Status = data.Status || undefined;
    this.Url = data.Url || data.URL || undefined;
    this.PartitionKey = data.PartitionKey || undefined;
    this.RowKey = data.RowKey || undefined;

    this.Location = this.calculateLocation();
  }

  calculateLocation() {
    if (this.MaxLat && this.MaxLong && this.MinLat && this.MinLong) {
      const midLat = (parseFloat(this.MaxLat) + parseFloat(this.MinLat)) / 2;
      const midLong = (parseFloat(this.MaxLong) + parseFloat(this.MinLong)) / 2;

      return {
        latitude: midLat,
        longitude: midLong,
        latlng: `${midLat}, ${midLong}`,
      };
    } else {
      return undefined;
    }
  }
}
